<template>
<div class="c-awards c-home c-home--has-grid"  v-on:mousemove="update_parallax">
    <div class="c-awards__parallax-bg" :style="parallaxBg">
    </div>
    <GridBackground />
    <div class="c-awards__wrapper">
        <div v-if="$mq != 'sm'" class="c-awards__header">
            <div class="c-awards__header-inner">
                <span class="c-awards__header--gold">5</span> National Award Winners
            </div>
        </div>
        <div class="c-awards__slider">
            <div v-if="active_award_content && $mq != 'sm'" class="c-awards__details">
                <ul class="c-awards__details-items reset-list">
                    <li class="c-awards__details-item" v-for="(item,index) in active_award_content.awards" :key="index">
                    {{ item }}
                    </li>
                </ul>
                <div class="c-awards__details-title">
                    {{ active_award_content.title }}
                </div>
            </div>
            <slick class="c-awards_list" v-if="awards_content" :options="slick_options" ref="slick" @beforeChange="handleBeforeChange">
                <div class="c-awards__group-container" v-for="(group,index) in awards_content" :key="index">
                    <div class="c-awards__group">
                        <div class="c-awards__item" :style="parallaxFg" :class="{'is-active': item.id == active_award_content.id, 'is-coach' : item.id >= 3 }" v-for="(item,index) in group" :key="index">
                            <div v-if="$mq != 'sm'" class="c-awards__item-image" :style="{backgroundImage:  'url(' + item.image + ')'}"></div>
                            <div v-if="$mq == 'sm'" class="c-awards__item-details" :class="{'is-coach' : item.id >= 3 }">
                                <ul class="c-awards__item-details-list reset-list" :class="{'is-overflow' : item.id == 0 || item.id == 3}">
                                    <li class="c-awards__item-details-list-item" v-for="(award,index) in item.awards" :key="index">
                                    {{ award }}
                                    </li>
                                </ul>
                                <div class="c-awards__item-details-title">
                                    {{ item.title}}
                                </div>
                            </div>
                            <div v-if="$mq == 'sm'" class="c-awards__item-image-mobile">
                                <img :src="item.mobile_image" :alt="item.title"/>
                            </div>
                            <button class="c-awards__item-button" aria-label="toggle player" @click="active_award_content = item">
                                <span class="c-awards__pulse"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </slick>
        </div>
    </div>
    <div class="c-awards__footer-wrapper">
        <Undefeated v-if="$mq != 'sm'" />
        <GlitchText :text="glitch_text"/>
    </div>
</div>
</template>

<script>
import Slick from 'vue-slick'
import '../../node_modules/slick-carousel/slick/slick.css'
import _ from 'lodash'
import GridBackground from '@/components/GridBackground'
import GlitchText from '@/components/GlitchText.vue'
import Undefeated from '@/components/Undefeated.vue'

export default {
    name: 'HomeAwards',

    components: {
        Slick,
        GridBackground,
        GlitchText,
        Undefeated
    },

    data: () => ({
        active_award_content:false,
        awards_data: [],
        awards_items:[
            {
                id:0,
                title: 'Joe Burrow #9 QB',
                awards: ['The Heisman', 'AP Player of the Year','Golden Arm', 'Walter Camp', 'Davey O\'Brien', 'Maxwell'],
                image: require('../assets/joeb.png'),
                mobile_image: require('../assets/joeb.png')
            },
            {
                id:2,
                title: 'Ja\'Marr Chase #1 WR',
                awards: ['Biletnikoff Award'],
                image: require('../assets/chase.png'),
                mobile_image: require('../assets/chase.png')
            },
            {
                id:1,
                title: 'Grant Delpit #7 S',
                awards: ['Jim Thorpe Award'],
                image: require('../assets/delpit.png'),
                mobile_image: require('../assets/delpit.png')
            },
            {
                id:3,
                title: 'Ed Orgeron',
                awards: ['AP Coach of the Year', 'Home Depot Coach of the Year Award', 'Eddie Robinson Coach of the Year Award', 'Walter Camp Football Foundation Coach of the Year'],
                image: require('../assets/coacho_tablet.png'),
                mobile_image: require('../assets/coacho_tablet.png')
            },
            {
                id:4,
                title: 'Joe Brady',
                awards: ['	Broyles Award '],
                image: require('../assets/brady_tablet.png'),
                mobile_image: require('../assets/brady_tablet.png')
            }
        ],
        slick_options: {
            slidesToShow: 1,
            slidesToScroll:1,
            infinite:false
        },
        glitch_text: 'DIFFERENCE MAKERS.',
        parallaxX:0,
        parallaxY:0,
    }),

    methods: {
        get_data() {
            this.active_award_content = this.awards_items[0];
        },
        update_parallax: _.throttle(function(event) {
            let x = event.clientX;
            let y = event.clientY;
            let screenWidth = window.innerWidth;
            let screenHeight = window.innerHeight;

            this.parallaxX = x/screenWidth;
            this.parallaxY = y/screenHeight;

        },20),
        handleBeforeChange(e,slick,CurrentSlide,nextSlide){
            this.active_award_content = nextSlide ? this.awards_items[3] : this.awards_items[0];
        }
    },

    created() {
        this.get_data();
    },

    computed: {
        parallaxBg: function(){
            return this.$mq == 'sm' ? `` : `transform:translate(-${this.parallaxX * 15}px, -${this.parallaxY * 15}px)`;
        },
        parallaxFg: function(){
            return this.$mq == 'sm' ? `` : `transform:translate(${this.parallaxX * 22}px, ${this.parallaxY * 22}px)`;
        },
        awards_content(){
            let count = this.$mq == 'sm' ? 1 : 3;
            return _.chunk(this.awards_items, count);
        }
    },
     watch: {
        awards_content: function () {

            this.$refs.slick.destroy()
            
            this.$nextTick(() => {
                this.$refs.slick.create()
            });
        }
    }
}
</script>

<style lang="scss">
    @import "../styles/imports";
    .c-awards{
        display: block;
        width:100vw;
        height:100vh;
        overflow:hidden;
        button.slick-prev, button.slick-next{
            @include appearance;
            position: absolute;
            top:50%;
            left:0;
            color:$white;
            z-index: 10;
            width: 48px;
            height: 48px;
            font-size: 0;
            transition:0.3s;
            
            &::after{
                position: absolute;
                top: 50%;
                left:50%;
                font-family: 'feather';
                content:'\e828';
                font-size: 24px;
                color:$white;
                @include transform(translate(-50%,-50%));
                transition: 0.2s;
            }
            &:hover{
                cursor: pointer;
                &::after{
                    color: $gold;
                }
            }
        }
        button.slick-next{
            left:auto;
            right:0;
            
            &::after{
                content:'\e829';
            }
        }
        button.slick-disabled{
            opacity:0;
            pointer-events:none;
        }
    }

    @media all and (min-width:$small-breakpoint){
        .c-awards{
            button.slick-prev, button.slick-next{
                top:48px;
                left:48px;
                &::before{
                    content:'PLAYERS';
                    font-size:1rem;
                    color:$gold;
                    letter-spacing:2px;
                    position:absolute;
                    top:0;
                    left:0;
                    @include transform(translateY(-100%));

                }
            }
            button.slick-next{
                left:auto;
                right:48px;
                &::before{
                    content:'COACHES';
                    left:auto;
                    right:0;
                }
            }
        }
    }
</style>
<style lang="scss" scoped >
    @import "../styles/imports";

        @keyframes pulse {
        0% { box-shadow: 0 0 0 0 #fff; }
        }
        @keyframes scroll {
            0% { @include transform(translateX(25%)); opacity:0 }
            5% {opacity: 1;}
            90% { opacity: 1;}

        }

    .c-awards{
        @include flex-container;
        overflow:hidden;
        position:relative;
        .c-awards{
            &__footer-wrapper{
                position:absolute;
                bottom:60px;
                left:50%;
                @include transform(translateX(-50%));
            }
            &__parallax-bg{
                position: absolute;
                width:120vw;
                height:120vh;
                top:-10vh;
                left:-10vw;
                background: url('../assets/scratch_bkg.jpg') center no-repeat; background-size: cover;
            }
            &__list{
                width:100%;
                margin:0 auto;
            }
            &__header{
                color:$white;
                text-transform:uppercase;
                font-weight:700;
                text-align:center;
                font-size:2.250rem;
                letter-spacing:1.125rem;
                line-height:1.2;
                @include flex-container;
                @include align-center;
                @include justify-center;
                @include flex-item(0 0 auto);
                min-height:calc(100vw * 0.6 * 0.33333 * 0.5625);
                position:relative;
                z-index:10;
            }
            &__header--gold{
                color:$gold;
            }
            &__wrapper{
                height:auto;
                width:100%;
                @include flex-container;
                @include flex-column;
                @include align-stretch;
                @include justify-start;
            }
            &__slider{
                @include flex-item(1 1 auto);
                position:relative;
            }
            &__details{
                position:absolute;
                top:0;
                left:0;
                width:100%;
                text-align:center;
                z-index:10;
            }
            &__details-items{
                padding:28px 140px 26px;
                @include flex-container;
                @include align-center;
                @include justify-center;
                @include flex-wrap;
            }
            &__details-item{
                color:$white;
                font-size:0.75rem;
                letter-spacing:0.375rem;
                text-transform:uppercase;
                line-height:1.2;
                font-weight:400;
                padding-right:30px;
                margin:4px 0;
                position:relative;
                &::after{
                    position:absolute;
                    top:50%;
                    right:15px;
                    width:2px;
                    height:2px;
                    border-radius:50%;
                    content:'';
                    background:$white;
                }
                &:last-child{
                    padding-right:0;
                    &::after{
                        display:none;
                    }
                }
            }
            &__details-title{
                color:$gold;
                text-align:center;
                font-size:1rem;
                font-weight:700;
                text-transform:uppercase;
                letter-spacing:0.5rem;
            }
            &__group{
                @include flex-container;
                @include justify-center;
                height:auto;
                overflow:hidden;
            }
            &__item{
                
                @include flex-item(0 0 auto);
                width:100%;
                position:relative;                
                overflow:hidden;
                min-height:calc( 100vh - (100px));
                @include flex-container;
                @include flex-column;
                @include align-center;
            }
            &__item-details{
                @include flex-item(1 0 auto);
                width:100%;
                padding:40px 0;
                overflow:hidden;
                &.is-coach{
                    @include flex-item(0 0 auto);
                }
            }
            &__item-details-list{
                @include flex-container;
                @include align-center;
                @include justify-start;
                position:absolute;
                top:0;
                left:50%;
                @include transform(translateX(-50%));
                &.is-overflow{
                    left:0;
                    @include transform(translateX(-100%));
                    opacity:0;
                    animation: scroll 24s;
                    animation-timing-function:linear;
                    animation-iteration-count: infinite;
                }                
            }
            &__item-details-list-item{
                color:$white;
                font-size:0.75rem;
                letter-spacing:0.375rem;
                text-transform:uppercase;
                line-height:1.2;
                font-weight:400;
                padding-right:30px;
                margin:4px 0;
                white-space:nowrap;
                position:relative;
                &::after{
                    position:absolute;
                    top:50%;
                    right:15px;
                    width:2px;
                    height:2px;
                    border-radius:50%;
                    content:'';
                    background:$white;
                }
                &:last-child{
                    padding-right:0;
                    &::after{
                        display:none;
                    }
                }
            }
            &__item-details-title{
                font-weight:700;
                color:$gold;
                text-align:center;
                text-transform:uppercase;
                font-size:1rem;
                letter-spacing:0.5rem;
            }
            &__item-image-mobile{
                @include flex-item(0 1 auto);
            }
            &__item-image{
                height:100%;
                position:absolute;
                width:100%;
                top:0;
                left:0;               
                background:top center no-repeat;
                background-size:auto 100%;
                
            }
            &__item-button{
                @include appearance;
                display:none;
                position:absolute;
                top:48px;
                right:24px;
                height:48px;
                width:48px;
                border:solid 2px $white;
                border-radius:50%;
                background:rgba(255,255,255,0.5);
                animation: pulse 1.5s;
                animation-iteration-count: infinite;
                box-shadow: 0 0 0 1rem rgba(#fff,0);
                transition:0.4s;
                &:focus{
                    outline:none;
                }
                &:hover{
                    cursor:pointer;
                    &::before{
                        background:$purple;
                    }
                }
                &::before{
                    position:absolute;
                    top:50%;
                    left:50%;
                    @include transform(translate(-50%,-50%));
                    width:12px;
                    height:12px;
                    content:'';
                    background:$white;
                    border-radius:50%;
                    transition:0.4s;
                }
            }
            
        }
    }

    @media all and (min-width:$small-breakpoint){
        .c-awards{
            .c-awards{
                &__footer-wrapper{
                    position:static;
                    bottom:auto;
                    left:auto;
                    @include transform(none);

                }
                &__group{
                    padding-top:120px;
                }
                &__item{
                    width:25%;
                    display:block;
                    padding:0 24px;
                    min-height:calc( 100vh - (100vw * 0.6 * 0.33333 * 0.5625 * 2));
                    @include order(1);
                    &.is-active{
                        .c-awards__item-image{
                            filter:grayscale(0);
                        }
                        .c-awards__item-button{
                            animation:none;
                            background:$white;
                            &::before{
                                background:$purple;
                            }
                        }
                    }
                    &:nth-child(3){
                        @include order(0);
                    }
                    &.is-coach{
                        width:33.333%;
                    }
                }
                &__item-image{
                     filter:grayscale(1);
                     transition:filter 0.4s;
                }
                &__item-button{
                    display:block;
                }
            }
        }
    }

    @media all and (min-width:$medium-breakpoint){
        .c-awards{
            &__item-button{
                right:48px;
            }
        }

    }
</style>